module.exports = __webpack_public_path__ + "img/mood_sick.07972d0f.png";